/**
 * S3.5 - Section "Templates docx" de la page parametres CEE.
 * Affiche le statut Devis + AH + warnings (placeholders manquants).
 */

import { useEffect, useState } from 'react';
import * as ceeApi from '../../api/cee.js';

/** @returns {JSX.Element} */
export default function TemplateAdmin() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const r = await ceeApi.getTemplatesStatus();
      setData(r);
    } catch (err) {
      setError(err.message || 'Erreur chargement templates');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <section className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
      <h2 className="text-lg font-bold text-[#0f172a] mb-3">Templates docx (Devis / AH)</h2>
      {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-md px-3 py-2 mb-3 text-sm">{error}</div>}
      {loading && <p className="text-sm text-gray-500">Chargement...</p>}
      {data && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {['devis', 'ah'].map((type) => {
            const t = data[type];
            return (
              <div key={type} className={`border rounded-md p-3 ${t.valid ? 'border-emerald-200 bg-emerald-50' : 'border-red-200 bg-red-50'}`}>
                <div className="font-medium uppercase">{type}</div>
                <div className="text-xs text-gray-600 truncate" title={t.path}>{t.path}</div>
                <div className="text-xs text-gray-600">{Math.round(t.sizeBytes / 1024)} Ko</div>
                <div className="mt-2">
                  <span className={`inline-block px-2 py-0.5 text-xs rounded ${t.valid ? 'bg-emerald-200 text-emerald-800' : 'bg-red-200 text-red-800'}`}>
                    {t.valid ? 'Valide' : 'Manquants : ' + t.missing.join(', ')}
                  </span>
                </div>
                {t.extra.length > 0 && (
                  <div className="mt-1 text-xs text-gray-500">Extra : {t.extra.join(', ')}</div>
                )}
              </div>
            );
          })}
        </div>
      )}
      {data && data.warnings.length > 0 && (
        <div className="mt-3 text-xs text-orange-700">
          <div className="font-medium">Warnings actifs (a acquitter en DB)</div>
          <ul className="list-disc list-inside">
            {data.warnings.map((w) => (
              <li key={w.id}>{w.template_type} : {w.placeholder} ({w.status})</li>
            ))}
          </ul>
        </div>
      )}
      <div className="mt-3 text-xs text-gray-500">
        Note : pour mettre a jour les templates, copier les nouveaux .docx dans
        <code className="mx-1">server/src/services/cee/templates/</code>
        et redemarrer le serveur.
      </div>
    </section>
  );
}
